module.exports = __webpack_public_path__ + "img/logout.81dd1601.svg";